<template>
  <section class="max-w-screen-lg mx-auto p-5">
    <nav class="flex justify-between">
      <div class="flex space-x-1">
        <img @click="redirectToHomePage" src="/logo.png" alt="Logo" class="w-10 sm:w-12 my-auto pop-click" >
        <h6 class="text-purple-500 text-xl sm:text-2xl font-semibold my-auto">Privacy Policy</h6>
      </div>
      <div class="my-auto">
        <h6 @click="redirectToHomePage" class="text-base text-gray-400 pop-click hover:text-gray-500">Sign In</h6>
      </div>
    </nav>

    <main class="mt-5 mb-24 text-gray-500 font-semibold">

      <div class="max-w-lg mx-auto">
        <img src="/privacy/hero.png" alt="Business Woman">
        <h1 class="text-base sm:text-xl ml-10">Talk Chats Privacy Policy</h1>
      </div>

      <section class="w-full sm:w-5/6 lg:w-4/6 mt-5 sm:mt-10 pr-10">
        <h1 class="text-xl sm:text-3xl">
          You are entrusting us with your personal information when you utilize our services. We recognize that this is a significant duty, and we work hard to protect your data and provide you control.
        </h1>
        <div class="text-sm sm:text-base space-y-5 my-10 font-medium text-justify">
          <h2>
            When you sign up for  on our services through our third party authentication, you are providing us personal information such as display name, photo url and email.
          </h2>
          <h2>
            We also collect the content you provide in our platform such as chat messages and images which are linked to your unique identication.
          </h2>
          <h2>
            If you choose to remove your data on our platform  you can sign in and go to your profile to delete your information. Upon deleting your account we will still store chat messages and files so we can still provide good user experience to other users.
          </h2>
          </div>
          <div @click="redirectToHomePage" class="btn-default w-max m-0 px-4">
            Sign In Now
          </div>
      </section>
      
    </main>

  </section> 
</template>

<script>
export default {
  methods : {
    redirectToHomePage(){
      this.$router.push({path: '/sign-in'});
    }
  }
}
</script>

<style>

</style>